<button
  class="btn"
  [ngClass]="{ 'btn-selected': isSelected() }"
  (click)="onClick(data.key)">
  {{ data.label }}
</button>
